import { Directive, inject, OnInit, ViewContainerRef } from '@angular/core';
import { DropdownOverlayService } from '../../services/dropdown-overlay.service';

@Directive({
  selector: '[appDropdownOverlay]'
})
export class DropdownOverlayDirective implements OnInit {
  private readonly _viewContainerRef = inject(ViewContainerRef);
  private readonly _overlayService = inject(DropdownOverlayService);

  ngOnInit(): void {
    // Save the container reference so dropdowns can render into it.
    this._overlayService.containerRef = this._viewContainerRef;
  }
}
